import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import MyDigitalBusinessCard from '../../components/MyDigitalBusinessCard';

/**
 * TalentMyCard — the dedicated full-screen "My Card" page. Talent open this
 * to present their Digital Business Card in person (big QR to scan) or print
 * / save it as a PDF. Reuses the exact same card component as the dashboard.
 */
export default function TalentMyCard() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-b from-cyan-50 to-white py-6 px-4" data-testid="talent-my-card-page">
      <div className="max-w-md mx-auto">
        <Button
          variant="ghost"
          onClick={() => navigate('/talent/home')}
          className="mb-4 dbc-no-print"
          data-testid="my-card-back"
        >
          <ArrowLeft className="w-4 h-4 mr-1.5" /> Back to Home
        </Button>
        <MyDigitalBusinessCard presentation />
        <p className="text-center text-xs text-gray-400 mt-4 dbc-no-print">
          Hold this screen up so clients can scan the QR, or print / save it as a PDF.
        </p>
      </div>
    </div>
  );
}
